export const ENV = {
   PUBLIC_FF_URL: import.meta.env.VITE_APP_PUBLIC_FF_URL,
   STRIPE_ID: import.meta.env.VITE_APP_STRIPE_ID,
   CONFIGCAT_SDK_KEY: import.meta.env.VITE_APP_CONFIGCAT_SDK_KEY,
   NODE_ENV: import.meta.env.VITE_APP_NODE_ENV,
   MODE: import.meta.env.MODE,
   GOOGLE_MAPS_API_KEY: import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY,
   CAMPAIGN_WORKER_URL: import.meta.env.VITE_APP_CAMPAIGN_UI_WORKER_URL,
   CAMPAIGN_UI_WORKER_URL: import.meta.env.VITE_APP_CAMPAIGN_UI_WORKER_URL,
   TEXT_WORKER_API_URL: import.meta.env.VITE_APP_TEXT_WORKER_API_URL,
   PHONE_WORKER_API_URL: import.meta.env.VITE_APP_PHONE_WORKER_API_URL,
   CALL_WORKER_API_URL: import.meta.env.VITE_APP_CALL_WORKER_API_URL,
   LEAD_PROCESS_WORKER_URL: import.meta.env.VITE_APP_LEAD_PROCESS_WORKER_URL,
   FEATURE_DEMO_CONVERSATION: import.meta.env
      .VITE_APP_FEATURE_DEMO_CONVERSATION,
   VOICE_PROVIDER: import.meta.env.VITE_APP_VOICE_PROVIDER,
   // Plan 0003 — the MCP server's origin. The connect handoff builds its POST
   // target from THIS and a fixed path, never from a query parameter.
   //
   // Defaulted rather than required: there is ONE Nikaido API, and staging and
   // production are organizations inside it, not separate deployments. The
   // environment variable exists for local development and for the day that
   // stops being true; it is not what separates staging from production. That
   // is the publication id, which travels in the handle and never passes
   // through this app.
   NIKAIDO_MCP_URL:
      import.meta.env.VITE_APP_NIKAIDO_MCP_URL ??
      'https://nikaido-api.aunto.workers.dev',
}
